import data from "../../.sourceflow/team.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const team_helper = new CollectionHelper(data);
